import { useLayoutEffect, useEffect, createElement, Fragment } from 'react';
import { TypographyWrapperProps } from './types';
import { useDesignTokens } from './theme';
import { getTypographyWrapperDataProvider } from './__internal__/TypographyWrapperDataProvider';

/**
 * Handles adding the base font size to the document as well as making a call to load
 * the location of the font families from the Viya font service. Applications should
 * only contain a single `TypographyWrapper`. Applications making use of `AppRoot`
 * will get a TypographyWrapper by default.
 */
export const TypographyWrapper = ({
  children,
  requestFonts,
  ignoreRootFontSize,
  dataProvider = getTypographyWrapperDataProvider(),
}: TypographyWrapperProps) => {
  const dt = useDesignTokens();

  useLayoutEffect(() => {
    if (ignoreRootFontSize) return;
    document.documentElement.style.fontSize = dt.fontNova.size.base;
  }, [dt.fontNova.size.base, ignoreRootFontSize]);

  useEffect(() => {
    if (requestFonts === false || !dataProvider.getFontFaceDeclarations) return;
    dataProvider.getFontFaceDeclarations();
  }, [dataProvider, requestFonts]);

  return <Fragment>{children}</Fragment>;
};
